
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { AttendeeNotesFilterModel, IAttendeeNote, IAttendeeNotes } from './attendeenotes-model';

@Injectable()
export class AttendeeNotesService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${AttendeeNotesService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/attendeenotes';

    private static get URL_ATTENDEES(): string { return `${environment.api.baseUrl}${environment.api.prefix}${AttendeeNotesService.ENDPOINT_ATTENDEES}`; }
    private static readonly ENDPOINT_ATTENDEES = '/attendees/{attendeeId}/attendeenotes';

    // Attendee notes
    public getAttendeesNotes(filterModel: AttendeeNotesFilterModel, isExport: boolean = false): Observable<SuccessResponse<IAttendeeNotes> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<IAttendeeNotes>>(AttendeeNotesService.URL + '/filters', {filterModel, isExport}).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public completeAttendeesNotes(ids: string[]): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(AttendeeNotesService.URL + '/completes', {ids}).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    // Attendees
    public getAttendeeNote(attendeeId: string, attendeeNoteId: string): Observable<SuccessResponse<IAttendeeNote> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IAttendeeNote>>(AttendeeNotesService.URL_ATTENDEES.replace('{attendeeId}', attendeeId) + '/' + attendeeNoteId).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getAttendeeNotes(attendeeId: string): Observable<SuccessResponse<IAttendeeNotes> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IAttendeeNotes>>(AttendeeNotesService.URL_ATTENDEES.replace('{attendeeId}', attendeeId)).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public addAttendeeNote(attendeeId: string, attendeeNote: IAttendeeNote): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(AttendeeNotesService.URL_ATTENDEES.replace('{attendeeId}', attendeeId), attendeeNote).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public updateAttendeeNote(attendeeId: string, attendeeNote: IAttendeeNote): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(AttendeeNotesService.URL_ATTENDEES.replace('{attendeeId}', attendeeId) + '/' + attendeeNote?.id, attendeeNote).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public deleteAttendeeNote(attendeeId: string, attendeeNoteId: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .delete<SuccessResponse<boolean>>(AttendeeNotesService.URL_ATTENDEES.replace('{attendeeId}', attendeeId) + '/' + attendeeNoteId).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

}
